var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.512,
    height: 12,
    viewBox: "0 0 12.512 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2229",
    "data-name": "Rectangle 2229",
    width: 12.512,
    height: 12,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10200",
    "data-name": "Group 10200",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10199",
    "data-name": "Group 10199",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27566",
    "data-name": "Path 27566",
    d: "M9.484,12A1.016,1.016,0,0,1,9,11.881L6.268,10.441,3.505,11.881a1.03,1.03,0,0,1-1.493-1.087l.521-3.045L.312,5.565A1.029,1.029,0,0,1,.883,3.808L3.94,3.362,5.332.576a1.029,1.029,0,0,1,1.848,0l1.368,2.77,3.079.462A1.029,1.029,0,0,1,12.2,5.565L9.988,7.72l.513,3.073A1.035,1.035,0,0,1,9.484,12M1.011,4.848l2.21,2.159a1.021,1.021,0,0,1,.3.909L3,10.962l.276.474-.232-.443L5.775,9.555a1.041,1.041,0,0,1,.96,0l2.734,1.439.045-.031L8.989,7.918a1.036,1.036,0,0,1,.3-.912L11.5,4.848,11.484,4.8,8.426,4.353a1.033,1.033,0,0,1-.777-.565L6.281,1.016c0-.007-.008-.015-.026-.015L4.86,3.787a1.033,1.033,0,0,1-.777.565L1.026,4.8l-.368.41Z",
    transform: "translate(0 0)",
    fill: "#152c40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon2);
export default __webpack_public_path__ + "static/media/social-icon2.67f24f1179780d7ba93363f6127b2701.svg";
export { ForwardRef as ReactComponent };